module.exports = __webpack_public_path__ + "static/media/montagem_frances.8541e6b3.png";